module.exports = __webpack_public_path__ + "img/roll2.a39f9ee6.jpeg";